<div class="p-4 d-flex flex-column h-100">
    <div class="d-flex title flex-nowrap">
        <i class="ph-bold me-2 ph-warning font35"></i>
        <div i18n>Ci dispiace, si è verificato un errore!</div>
    </div>
    <div class="mt-3" i18n>Aggiorna la pagina o riprova più tardi. Se il problema persiste, ti invitiamo a contattare l’assistenza.</div>
</div>